import React from 'react';
import "./filter.scss";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';
import { Constants, ImageConstants, AccessRights } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import SchoolApi from '../../../../apis/school'
import MasterDataApi from '../../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import CommonApi from '../../../../apis/common'
import 'bootstrap-daterangepicker/daterangepicker.css';
import PillButtonSelect from '../../../common/pill-button-select/pill-button-select';
import SessionCache from '../../../routes/session-cache';
import TestApi from '../../../../apis/test';
import CwConfirmationModal from '../../../common/cw-confirmation-modal/cw-confirmation-modal';


class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: true,
        questionCount: 0,
        disableGo: true,
        questionSource: 'countingwell',
        boardsDropdownItems: [],
        classDropdownItems: [],
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: {},
        selectedClass: {},
        selectedSection: [],
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        selectedQuestionSetId: '',
        selectedQuestionSetTitle: '',
        disableClass: true,
        disableChapters: true,
        durationDropDown: [],
        singleChapterDropdown: [{ title: "15 Mins", value: 15 }],
        selectedChapter: [],
        duration: 15,
        maxChapterSelection: 4,
        autoNext : false,
        sectionDropdownItems: [],
        assessmentType: 'DIAGNOSTIC',
        subSubjectsDropDownItems: [
            {
                title: 'Physics',
                value: '6825751af19678f87dd72e9c'
            },
            {
                title: 'Chemistry',
                value: '68ad5e67a5611fe85d55d17c'
            },
            {
                title: 'Biology',
                value: '68ad5e67a5611fe85d55d17d'
            }
        ]
    }

    classSectionHash = {}
    config = {}
    sectionHash = {}


    accessRights = SessionCache.getAllowedModule()

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()

    }

    componentDidMount() {
        this.getClasses()
        if (this.props.isClonePractice) {
            let homeworkAssignPayload = this.props.selectedHomework

            this.onSelectPillButton({ title: homeworkAssignPayload.board, value: homeworkAssignPayload.board }, "selectedBoard")

            setTimeout(() => {
                this.onSelectDropDown({ title: homeworkAssignPayload.class, value: homeworkAssignPayload.class, }, "selectedClass")
            }, 1000)

            // setTimeout(() => {
            //     this.onSelectDropDown({ value: homeworkAssignPayload.sectionId, sectionId: homeworkAssignPayload.sectionId, title: homeworkAssignPayload.section }, "selectedSection")
            // }, 1000)

            setTimeout(() => {
                this.onSelectChapter({ value: homeworkAssignPayload.chapterKey }, "selectedChapter")
            }, 2000)
        }
        this.getMisc()

        console.log(this.props.selectedHomework)

    };


    getMisc() {
        let payload = {
            "type": "ASSESSMENT_META"
        }
        CommonApi.getMisc(payload)
            .then(response => {
                let misc = response[0]
                this.config = misc
                console.log(this.config)
                this.setState({ maxChaptersAllowed: misc.maxChaptersAllowed })
            }).catch(err => {
            })
    }


    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: boards[0] })
                }
                console.log(classes)
                this.setState({ classDropdownItems: classes })
            }).catch(err => {
            })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.value
        if (!payload.board) payload.board = this.state.selectedBoard?.value

        if (this.classSectionHash[payload.board + payload.class]) {
            this.setState({ sectionDropdownItems: this.classSectionHash[payload.board + payload.class], selectedSection: "" })
            // this.reloadDropdown()
            return
        }

        console.log('sections get')

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                for (let i = 0; i < response.response.length; i++) {
                    if (!response.response[i].noSectionInClass) {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                            sectionId: response.response[i]._id
                        })
                    }

                    this.sectionHash[response.response[i]._id] = response.response[i].section
                }

                console.log(sections)


                this.classSectionHash[payload.board + payload.class] = sections?.length ? sections : null
                this.setState({ sectionDropdownItems: sections, selectedSection: "", reloadSectionDropdown: true }, () => {
                    this.setState({ reloadSectionDropdown: false })
                })
                // this.reloadDropdown()
            }).catch(err => {
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.value
        if (!payload.board) payload.board = this.state.selectedBoard?.value



        let subSubjectNames = [], subSubjectIds = []

        if (this.state.selectedSubSubjectId && this.state.selectedSubSubjectId.length) {
            subSubjectNames = this.state.selectedSubSubjectId.map(item => item.title)
            subSubjectIds = this.state.selectedSubSubjectId.map(item => item.value)
        }


        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID) {
            payload.subSubjectId = subSubjectIds
        }

        if (this.props.type === Constants.CLICKER_ASSESSMENT) {
            payload.isClickerAssessment = true
        } else {
            payload.isClickerAssessment = false
        }

        if (!payload.class) return
        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })
                }
                this.setState({ chapterDropDownItems: chapters, reloadChapterDropdown: true }, () => {
                    this.setState({ reloadChapterDropdown: false })
                })
            }).catch(err => {
            })
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectPillButton = (option, key) => {
        console.log(option)
        // let reloadChapterDropdown = false, selectedChapter = this.state.selectedChapter
        if (key === "selectedSection") {
            // reloadChapterDropdown = true
            // selectedChapter = null
        }


        this.setState({ [key]: option }, () => {
            if (key == "selectedBoard") {
                // this.getClasses()
                // this.setState({ sectionDropdownItems: [] })
                // if (this.props.onBoardChange) this.props.onBoardChange()
                // this.setState({
                //     // selectedClass: "",
                //     // selectedSection: "",
                //     questionSource: "countingwell",
                //     duration: 15,
                //     // selectedChapter: []
                // })
            }
            if (key === "selectedClass") {
                this.getSections({ class: option?.value })
                this.getChapters()
            }

            if (key === "selectedSection") {
                this.setState({ reloadChapterDropdown: false }, () => {
                    this.onMultiSelectDropdown([], "selectedChapter")
                })
                this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            } else {
                this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            }
        })
    }

    onSelectDropDown = (option, key) => {
        console.log(option, key)
        this.setState({ [key]: option, reloadClassDropdown: true }, () => {
            if (key === "selectedClass") {
                this.setState({ reloadClassDropdown: false })
                this.getSections({ class: option?.value })
                this.getChapters()
            }

            if (key === "selectedSection") {
                this.setState({ reloadChapterDropdown: false }, () => {
                    this.onMultiSelectDropdown([], "selectedChapter")
                })
                this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            } else {
                this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            }

        })
    }

    onSelectSection = (options) => {
        let values = options.map(option => option?.value)
        this.setState({ selectedSection: values, reloadSectionDropdown: false }, () => {
            // this.onMultiSelectDropdown([], "selectedChapter")
            this.emitChanges(null, true)
            this.setState({ reloadSectionDropdown: false })
        })
    }


    onMultiSelectDropdown = (options, key) => {
        console.log(options, key)
        let value = []
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option)

            // if (key == "selectedChapter") {
            //     let chapterInfo = this.config.chapters
            //     let configs = chapterInfo[value.length]
            //     if (configs) {
            //         let dropdownList = []
            //         configs.forEach(element => {
            //             let obj = {
            //                 title: `${element.duration?.value} ${element.duration?.unit}`,
            //                 value: element.duration?.value
            //             }
            //             dropdownList.push(obj)
            //         });
            //         this.setState({ durationDropDown: dropdownList, reloadDurationDropdown: true }, () => {
            //             this.setState({ reloadDurationDropdown: false })
            //         })
            //     } else {
            //         this.setState({ durationDropDown: [], duration: "", reloadDurationDropdown: true }, () => {
            //             this.setState({ reloadDurationDropdown: false })
            //         })
            //     }
            // }
        }
        this.setState({ reloadChapterDropdown: false, [key]: value, duration: "" }, () => {
            this.setState({ reloadChapterDropdown: false })


            if (this.props.type === Constants.CLICKER_ASSESSMENT) {
                this.emitChanges(true)
            } else {
                if (value.length > 1) {
                    this.emitChanges(true)
                } else {
                    if(!value.length) {
                        this.setState({selectedQuestionSetId : ''})
                        this.emitChanges(true)
                        return
                    }
                    this.getQuestionSet()
                }
            }
        })
    }

    handleDateEvent = (event, picker) => {
        this.startDate = new Date(picker.startDate);
        this.setState({ selectedDate: this.startDate.toLocaleDateString() });
        this.emitChanges()
    }


    emitChanges(reloadQuestion, reloadStudent) {

        let chapters = []

        if (this.state.selectedChapter && this.state.selectedChapter?.length) {
            chapters = this.state.selectedChapter?.map(item => {
                return {
                    key: item.value,
                    title: item.title
                }
            })
        }

        // console.log(this.state.selectedSubSubjectId)

        let subSubjectNames = [], subSubjectIds = [], clickerAssessmentTitle = ''

        if (this.state.selectedSubSubjectId && this.state.selectedSubSubjectId.length) {
            subSubjectNames = this.state.selectedSubSubjectId.map(item => item.title)
            subSubjectIds = this.state.selectedSubSubjectId.map(item => item.value)
        }

        if ((this.state.selectedSubSubjectId && this.state.selectedSubSubjectId.length > 1) &&
            (this.state.selectedChapter && this.state.selectedChapter.length > 1)) {
            clickerAssessmentTitle = this.state.clickerAssessmentTitle
        }

        let payload = {
            schoolId: this.user.schoolInfo.schoolCode,
            board: this.state.selectedBoard?.value,
            class: this.state.selectedClass?.value,
            section: this.sectionHash,
            sectionId: this.state.selectedSection,
            chapters: chapters,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()) : "",
            masterDataId: this.state.masterDataId,
            duration: chapters.length === 1 ? 15 : this.state.duration,
            questionSource: this.state.questionSource,
            assessmentType: this.state.assessmentType,
            autoNext : this.state.autoNext
        }

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID) {
            payload.subSubjectId = subSubjectIds
            payload.subSubjectName = subSubjectNames
        }

        if (clickerAssessmentTitle) {
            payload.clickerAssessmentTitle = clickerAssessmentTitle
        }

        if (this.state.selectedQuestionSetId && this.state.selectedChapter && this.state.selectedChapter?.length === 1) {
            payload.selectedQuestionSetId = this.state.selectedQuestionSetId
            payload.selectedQuestionSetTitle = this.state.selectedQuestionSetTitle
        }


        if (this.state.selectedChapter && this.state.selectedChapter.length > 1 && this.state.questionCount) {
            payload.questionCount = this.state.questionCount
        }

        console.log(payload)

        if (this.props.onGo) {
            this.props.onGo(payload, reloadQuestion, reloadStudent)
        }
    }

    // onSelectDropDown = (option, key) => {
    //     this.setState({ [key]: option?.value }, () => {
    //         this.emitChanges(key == "duration")
    //     })
    // }

    onSelectChapter = (option) => {
        if (option) option = [option]
        this.setState({ "selectedChapter": option, reloadChapterDropdown: true }, () => {
            this.setState({ reloadChapterDropdown: false })

            if (this.props.type === Constants.CLICKER_ASSESSMENT) {
                this.emitChanges(true)
            } else {
                this.getQuestionSet()
            }


            if (this.props.resetSelectedQuestions) this.props.resetSelectedQuestions()
        })
    }

    getQuestionSet() {

        let chapters = []

        if (this.state.selectedChapter && this.state.selectedChapter?.length) {
            chapters = this.state.selectedChapter?.map(item => {
                return item.value
            })
        }

        // console.log(this.state.selectedChapter, chapters.join(','))

        if (!chapters.length) return;

        let payload = {
            chapterKey: chapters.join(','),
            class: this.state.selectedClass?.value
        }

        // console.log('called question set')

        TestApi.getQuestionSet(payload).then(response => {
            // console.log(response)

            let questionSetDropdownItems = []
            let homeworkCreatedQuestionCategoryHash = response.homeworkCreatedQuestionCategoryHash

            response.questionSetIdsList.forEach((item, index) => {
                let obj = {
                    title: `Set ${index + 1}`,
                    value: item,
                    isAlreadyHomeworkCreated: homeworkCreatedQuestionCategoryHash[item] ? true : false
                }

                questionSetDropdownItems.push(obj)

            })

            if (questionSetDropdownItems && questionSetDropdownItems.length === 1) {
                this.setState({ questionSetDropdownItems, reloadQuestionSetDropdown: true }, () => {
                    this.setState({ reloadQuestionSetDropdown: false })
                    this.onSelectQuestionSet(questionSetDropdownItems[0])
                })
            } else {
                this.setState({ questionSetDropdownItems, reloadQuestionSetDropdown: true }, () => {
                    this.setState({ reloadQuestionSetDropdown: false })
                })
            }

        }).catch(err => {
            console.log(err)
        })
    }

    onSelectQuestionSet(option) {
        // console.log(option)

        let showHomeworkAlreadyCreatedForSetPopup = false

        if (option?.isAlreadyHomeworkCreated) {
            showHomeworkAlreadyCreatedForSetPopup = true
        }



        if (this.state.questionSetDropdownItems && this.state.questionSetDropdownItems.length > 1 && showHomeworkAlreadyCreatedForSetPopup) {
            this.setState({ selectedQuestionSetId: option?.value, selectedQuestionSetTitle: option?.title, showHomeworkAlreadyCreatedForSetPopup }, () => {

            })
        } else {
            this.setState({ selectedQuestionSetId: option?.value, selectedQuestionSetTitle: option?.title }, () => {
                this.emitChanges(true)
            })
        }
    }

    onSelectSubSubject = (option) => {
        if (option) option = [option]
        this.setState({ "selectedSubSubjectId": option }, () => {
            this.emitChanges(true)
            if (this.props.resetSelectedQuestions) this.props.resetSelectedQuestions()
        })
    }

    getChapterSelectedOrNot(value) {
        let chapters = this.state.selectedChapter || []
        for (let i = 0; i < chapters.length; i++) {
            if (chapters[i].value === value) return true
        }

        return false
    }

    setQuestionSource = val => {
        this.setState({ questionSource: val }, _ => {
            this.emitChanges(true)
        })
    }

    setAssessmentType(type) {
        this.setState({ assessmentType: type }, () => {
            this.emitChanges(true)
        })
    }

    onOk() {
        this.setState({ showHomeworkAlreadyCreatedForSetPopup: false })
        this.emitChanges(true)
    }

    cancelPopup() {

        let selectedQuestionSetId = this.state.selectedQuestionSetId
        let selectedQuestionSetTitle = this.state.selectedQuestionSetTitle


        this.setState({
            showHomeworkAlreadyCreatedForSetPopup: false, selectedQuestionSetId,
            selectedQuestionSetTitle
        }, () => {
            // this.setState({reloadQuestionSetDropdown : false})
        })

    }

    setStatus() {
            this.setState({ autoNext: !this.state.autoNext }, () => {
                this.emitChanges()
            })
    }

    handleChange = (event) => {
        const value = +event.target.value;

        // Prevent values above 50
        if (value <= 50) {
            this.setState({ questionCount: value }, () => {
                this.emitChanges(true)
            });
        }
    };

    handleClickerAssessmentTitleChange = (event) => {
        this.setState({ clickerAssessmentTitle: event.target.value }, () => {
            this.emitChanges(true)
        });
    }

    render() {
        const { questionSource } = this.state
        return (

            <div className="new-test-filter">
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">

                                 {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Board<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectPillButton(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}

                                                />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                        </div>
                                        : ""
                                }

                                {
                                    this.user.subjectId === Constants.SCIENCE_SUBJECTID ?
                                        this.accessRights["CLICKER_REGISTRAION"] ?
                                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                <div className="filter-input-label">
                                                    Subjects<span className='text-danger'>*</span>
                                                </div>
                                                <div className={this.props.isCreate && !this.state.subSubjectId ? 'error-border' : ''}>
                                                    <DropdownV4
                                                        placeholder='Select a Subject'
                                                        options={this.state.subSubjectsDropDownItems}
                                                        onSelect={(option) => this.onMultiSelectDropdown(option, "selectedSubSubjectId")}
                                                        text={"title"}
                                                        multiSelect
                                                        value={this.state.subSubjectId}
                                                    />
                                                </div>
                                                {this.props.isCreate && !this.state.subSubjectId ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                            </div>
                                            :
                                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                <div className="filter-input-label">
                                                    Subjects<span className='text-danger'>*</span>
                                                </div>
                                                <div className={this.props.isCreate && !this.state.subSubjectId ? 'error-border' : ''}>
                                                    <Dropdown
                                                        placeholder='Select a Subject'
                                                        options={this.state.subSubjectsDropDownItems}
                                                        onSelect={(option) => this.onSelectSubSubject(option, "selectedSubSubjectId")}
                                                        text={"title"}
                                                        value={this.state.subSubjectId}

                                                    />
                                                </div>
                                                {this.props.isCreate && !this.state.subSubjectId ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                            </div>
                                        :
                                        <></>

                                }


                               

                                {

                                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                        <div className="filter-input-label">
                                            Class<span className='text-danger'>*</span>
                                        </div>
                                        <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                                            {!this.state.reloadClassDropdown ?
                                                <Dropdown
                                                    placeholder='Select a Class'
                                                    options={this.state.classDropdownItems}
                                                    onSelect={(option) => this.onSelectPillButton(option, "selectedClass")}
                                                    text={"title"}
                                                    value={this.state.selectedClass?.value}
                                                />
                                                :
                                                ""
                                            }

                                        </div>
                                        {this.props.isCreate && !this.state.selectedClass ? <div className='error-text text-danger'>Please Select a class</div> : ''}
                                    </div>

                                }
                                {

                                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                        <div className="filter-input-label">
                                            Section<span className='text-danger'>*</span>
                                        </div>
                                        <div className={this.props.isCreate && !this.state.selectedSection ? 'error-border' : ''}>
                                            {
                                                !this.state.reloadSectionDropdown ?
                                                    <DropdownV4
                                                        key="section-multi-select"
                                                        placeholder='Select a Section'
                                                        options={this.state.sectionDropdownItems}
                                                        onSelect={(option) => this.onSelectSection(option, "selectedSection")}
                                                        text={"title"}
                                                        multiSelect
                                                        value={this.state.selectedSection}
                                                    >
                                                    </DropdownV4>
                                                    : ""
                                            }
                                        </div>
                                        {this.props.isCreate && !this.state.selectedSection ? <div className='error-text text-danger'>Please Select a Section</div> : ''}
                                    </div>

                                }

                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Chapter<span className='text-danger'>*</span>
                                    </div>

                                    {
                                        this.accessRights["CLICKER_REGISTRAION"] ?
                                            <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                                {!this.state.reloadChapterDropdown ?
                                                    <DropdownV4
                                                        key="chapter-multi-select"
                                                        placeholder='Select Chapter'
                                                        options={this.state.chapterDropDownItems}
                                                        onSelect={(option) => this.onMultiSelectDropdown(option, "selectedChapter")}
                                                        text={"title"}
                                                        multiSelect
                                                        // max={this.state.maxChaptersAllowed || 4}
                                                        value={this.state.selectedChapter}
                                                    />
                                                    // <Dropdown
                                                    //     placeholder='Select Chapter'
                                                    //     options={this.state.chapterDropDownItems}
                                                    //     onSelect={(option) => this.onSelectChapter(option)}
                                                    //     text={"title"}
                                                    //     value={this.state.selectedChapter}
                                                    //     disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                                    // >
                                                    // </Dropdown> 
                                                    : ''
                                                }
                                            </div>
                                            :
                                            <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                                {!this.state.reloadChapterDropdown ?

                                                    <Dropdown
                                                        placeholder='Select Chapter'
                                                        options={this.state.chapterDropDownItems}
                                                        onSelect={(option) => this.onSelectChapter(option)}
                                                        text={"title"}
                                                        value={this.state.selectedChapter && this.state.selectedChapter.length && this.state.selectedChapter[0]?.value ? this.state.selectedChapter[0]?.value : '' }
                                                        disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                                    >
                                                    </Dropdown>
                                                    : ''
                                                }
                                            </div>

                                    }


                                    {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                                </div>


                                {
                                    this.props.type != Constants.CLICKER_ASSESSMENT ?
                                        <>
                                            {
                                                this.state.selectedChapter &&
                                                    this.state.selectedChapter.length === 1 &&
                                                    this.state.questionSetDropdownItems && this.state.questionSetDropdownItems.length > 1 ?

                                                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                        <div className="filter-input-label">
                                                            Question Set<span className='text-danger'>*</span>
                                                        </div>
                                                        <div className={this.props.isCreate && !this.state.selectedQuestionSetId ? 'error-border' : ''}>
                                                            {!this.state.reloadQuestionSetDropdown ?
                                                                <Dropdown
                                                                    placeholder='Select Question Set'
                                                                    options={this.state.questionSetDropdownItems}
                                                                    onSelect={(option) => this.onSelectQuestionSet(option)}
                                                                    text={"title"}
                                                                    value={this.state.selectedQuestionSetId}
                                                                // disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                                                >
                                                                </Dropdown>
                                                                : ''
                                                            }
                                                        </div>
                                                        {this.props.isCreate && !this.state.selectedQuestionSetId ? <div className='error-text text-danger'>Please Select a Question Set</div> : ''}
                                                    </div>
                                                    :
                                                    <></>
                                            }



                                            {
                                                this.state.selectedClass ?
                                                    <div className="col-lg-2 col-md-6 col-sm-12  pt-4">
                                                        <div className="filter-input-label">
                                                            Due Date
                                                        </div>
                                                        <div>
                                                            <DateRangePicker onHide={this.handleDateEvent} onCancel={() => { }}
                                                                autoApply={true}
                                                                initialSettings={{ singleDatePicker: true, minDate: new Date(), startDate: this.startDate, autoUpdateInput: false }}
                                                                locale={{
                                                                    'format': 'DD/MM/YYYY'
                                                                }}
                                                            ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedDate}></input>
                                                                {/* <img className='cursor-pointer' src={getImageSource(ImageConstants.CALENDAR)} /> */}
                                                            </DateRangePicker>

                                                        </div>
                                                    </div> : ""
                                            }

                                        </>
                                        :
                                        <></>
                                }

                                {
                                    this.state.selectedChapter && this.state.selectedChapter.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4 pl-3">
                                            <div className="filter-input-label">
                                                Number of Questions<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                                <input className='input-style'
                                                    type="number"
                                                    min="0"
                                                    max="50"
                                                    placeholder="Enter Question Count"
                                                    onChange={this.handleChange}
                                                    value={this.state.questionCount} />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                                        </div>
                                        :
                                        <></>
                                }

                                {
                                    this.user.subjectId === Constants.SCIENCE_SUBJECTID &&
                                        (this.state.selectedSubSubjectId && this.state.selectedSubSubjectId.length > 1) &&
                                        (this.state.selectedChapter && this.state.selectedChapter.length > 1) ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4 pl-3">
                                            <div className="filter-input-label">
                                                Enter Clicker Assessment Title<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                                <input className='input-style'
                                                    type="text"
                                                    placeholder="Enter Title"
                                                    onChange={this.handleClickerAssessmentTitleChange}
                                                    value={this.state.clickerAssessmentTitle} />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                                        </div>
                                        :
                                        (this.state.selectedChapter && this.state.selectedChapter.length > 1) ?
                                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4 pl-3">
                                                <div className="filter-input-label">
                                                    Enter Clicker Assessment Title<span className='text-danger'>*</span>
                                                </div>
                                                <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                                    <input className='input-style'
                                                        type="text"
                                                        placeholder="Enter Title"
                                                        onChange={this.handleClickerAssessmentTitleChange}
                                                        value={this.state.clickerAssessmentTitle} />
                                                </div>
                                                {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                                            </div>
                                            :
                                            <></>
                                }

                                {
                                    this.props.type === Constants.CLICKER_ASSESSMENT ?
                                        <div className='row'>
                                            <div className="col-lg-12 col-md-6 col-sm-12 d-flex">
                                                <div className='d-flex align-items-center ml-3 status-wrapper'>
                                                    <div className='d-flex align-items-center cursor-pointer justify-content-center' onClick={() => this.setStatus()}>
                                                        {
                                                            this.state.autoNext ? <div className="active-check-box">
                                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.GREEN_CHECK_BOX)} />
                                                            </div>
                                                                :
                                                                <div className="">
                                                                    <img className="gray-tick-icon" src={getImageSource(ImageConstants.GRAY_CHECK_BOX)} />
                                                                </div>
                                                        }
                                                    </div>
                                                    <div className="timer-wrapper-for-timer d-flex align-items-center">
                                                        <img className='timer-image pl-2' src={getImageSource(ImageConstants.BLOCK_TIMER)} />
                                                        <span className='timer-text pl-2'>Automatically Move to Next Question</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                }

                            </div>


                        </div>
                        :
                        ""

                }
                {
                    this.state.showHomeworkAlreadyCreatedForSetPopup ?
                        <CwConfirmationModal
                            onOk={() => this.onOk()}
                            close={() => this.cancelPopup()}
                            message={'Selected Set School Assignment already done. Are want to create the Same Set School Assignment Again ?'}
                        />
                        : <></>
                }
            </div>


        );
    }

}

export default FilterComponent;